/**
 * OAuth callback for Google Drive. Exchanges code for tokens and redirects to editor.
 */
import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAction } from 'convex/react';
import { api } from '../../convex/_generated/api';

export function GoogleDriveCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const exchangeGoogleCode = useAction(api.storageConfig.exchangeGoogleCode);
  const [status, setStatus] = useState<'exchanging' | 'ok' | 'error'>('exchanging');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    if (!code || !state) {
      setStatus('error');
      setError('Missing code or state');
      return;
    }
    const redirectUri = `${window.location.origin}/oauth/google-drive-callback`;
    exchangeGoogleCode({ code, accountId: state, redirectUri })
      .then(() => {
        setStatus('ok');
        navigate('/app/editor?drive=linked', { replace: true });
      })
      .catch((err) => {
        setStatus('error');
        setError(err instanceof Error ? err.message : 'Linking failed');
      });
  }, [searchParams, exchangeGoogleCode, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-foreground">
      <div className="text-center">
        {status === 'exchanging' && <p>Linking Google Drive…</p>}
        {status === 'ok' && <p>Drive linked. Redirecting…</p>}
        {status === 'error' && (
          <>
            <p className="text-destructive">{error}</p>
            <a href="/app/editor" className="text-primary underline mt-2 inline-block">
              Back to editor
            </a>
          </>
        )}
      </div>
    </div>
  );
}
